const API_BASE_URL = process.env.REACT_APP_API_URL;

// Get all promotions (for admin dashboard)
export async function getAllPromotions(params = {}) {
  try {
    const queryParams = new URLSearchParams();
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
    
    const url = `${API_BASE_URL}/api/promotions${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch promotions');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Get all promotions error:', error);
    throw error;
  }
}

// Get active promotions (for frontend)
export async function getActivePromotions() {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions/active`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch active promotions');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Get active promotions error:', error);
    throw error;
  }
}

// Get single promotion by ID
export async function getPromotionById(promotionId) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions/${promotionId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch promotion');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Get promotion by ID error:', error);
    throw error;
  }
}

// Get single promotion by custom ID
export async function getPromotionByCustomId(customId) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions/custom/${customId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch promotion');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Get promotion by custom ID error:', error);
    throw error;
  }
}

// Create promotion
export async function createPromotion(promotionData) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(promotionData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to create promotion');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Create promotion error:', error);
    throw error;
  }
}

// Update promotion by ID
export async function updatePromotion(promotionId, updateData) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions/${promotionId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to update promotion');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Update promotion error:', error);
    throw error;
  }
}

// Update promotion by custom ID
export async function updatePromotionByCustomId(customId, updateData) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions/custom/${customId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to update promotion');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Update promotion by custom ID error:', error);
    throw error;
  }
}

// Delete promotion (soft delete)
export async function deletePromotion(promotionId) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions/${promotionId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to delete promotion');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Delete promotion error:', error);
    throw error;
  }
}

// Delete promotion by custom ID (soft delete)
export async function deletePromotionByCustomId(customId) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions/custom/${customId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to delete promotion');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Delete promotion by custom ID error:', error);
    throw error;
  }
}

// Toggle promotion status
export async function togglePromotionStatus(promotionId) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions/${promotionId}/toggle`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to toggle promotion status');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Toggle promotion status error:', error);
    throw error;
  }
}

// Get promotion statistics
export async function getPromotionStats() {
  try {
    const response = await fetch(`${API_BASE_URL}/api/promotions/stats`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch promotion statistics');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Get promotion stats error:', error);
    throw error;
  }
}